export const tr = {
    'add-creatives': {
        one: 'Hedef kitle artırmak için {formats} kreatif formatını ekleyin',
        some: 'Hedef kitle artırmak için {formats} kreatif formatlarını ekleyin',
        many: 'Hedef kitle artırmak için {formats} kreatif formatlarını ekleyin',
        none: 'Hedef kitle artırmak için {formats} kreatif formatlarını ekleyin'
    },
    title: 'Uygun formatlarda kreatifleri yükleyin',
    'title-hint': 'Seçilen panolar için uygun kreatifler olmadığı için öneri gösterilir',
    'video-format': '{width}x{height}, {duration}sn.'
};
